import { client } from '@core/api/API'

export default {
  /**
   * @returns {Promise<axios.AxiosResponse<any>>}
   */
  async fetchToolTypes() {
    return client.get('/tool-types')
  },

  /**
   * @param {{
   *  numberOfPlants?: number,
   *  toolTypeId?: string,
   *  category?: string,
   *  brand?: string,
   *  search?: string,
   *  page?: number,
   *  limit?: number,
   * }} params
   * @returns {Promise<{ items: string[], total: number }>}
   */
  async fetchToolItems(params) {
    const response = await client.get('/tool-items', {
      params,
    })

    return response.data
  },

  /**
   * @returns {Promise<axios.AxiosResponse<any>>}
   */
  async fetchToolItemBrands() {
    return client.get('/tool-items/brands')
  },

  /**
   * @param {{
   *   numberOfPlants?: number,
   *   budget?: string,
   *   location?: string,
   * }} params
   * @returns {Promise<axios.AxiosResponse<any>>}
   */
  async fetchToolShoppingLists(params) {
    return client.get('/tool-shopping-lists', {
      params,
    })
  },

  /**
   * @returns {Promise<axios.AxiosResponse<any>>}
   */
  async fetchToolCategories() {
    return await client.get('/tool-items/categories')
      .then(res => res.data)
  },

  async createCustomToolItem(item) {
    return client.post('/tool-items/custom', item)
      .then(res => res.data)
  },

  async fetchToolRetailers() {
    return client.get('/tool-items/retailers')
      .then(res => res.data)
  },
}
